module.exports = __webpack_public_path__ + "media/images/views/job_share/step-5-533b361b2fd72e18bd34453f200d0cbd.png";